import { render, staticRenderFns } from "./EligibilityControl.vue?vue&type=template&id=2920c6ef&scoped=true"
import script from "./EligibilityControl.vue?vue&type=script&lang=js"
export * from "./EligibilityControl.vue?vue&type=script&lang=js"
import style0 from "./EligibilityControl.vue?vue&type=style&index=0&id=2920c6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920c6ef",
  null
  
)

export default component.exports